import React from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import Title from '../../utilities/other/title';

class GCF_TMT extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            gcf_score: '',
            tmt_a_sec: '',
            tmt_a_mistakes: '',
            tmt_b_sec: '',
            tmt_b_mistakes: '',
            errors: {}
        };
        this.onChange = this.onChange.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    componentDidMount() {
        if (this.props.data != null) {
            this.setState(this.props.data);
        }
    }

    onKeyDown(event) {
        if (['e', 'E', '+', '-', '.'].includes(event.key)) {
            event.preventDefault();
        }
    }

    async onChange(event) {
        const { name, value } = event.target;
        const errors = { ...this.state.errors };

        if (name === 'gcf_score') {
            if (value !== '' && Number(value) > 36) {
                errors.gcf_score = 'GCF score cannot exceed 36';
            } else {
                delete errors.gcf_score;
            }
        }

        if (value !== '' && Number(value) < 0) {
            errors[name] = 'Value cannot be negative';
        }

        await this.setState(prevState => ({ ...prevState, [name]: value, errors }));
        const { errors: _errors, ...data } = this.state;
        this.props.handler('gcf_tmt', data);
    }

    render() {
        const { errors } = this.state;
        return (
            <Container fluid>
                <Title>Georgia Complex Figure &amp; Trail Making Test</Title>
                <br />
                <Form>
                    <Row className="justify-content-center">
                        <Col xs={12} md={8} lg={6}>

                            <Form.Row>
                                <Form.Group as={Col} xs={6}>
                                    <Form.Label>GCF Score (max 36)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="gcf_score"
                                        value={this.state.gcf_score}
                                        onChange={this.onChange}
                                        onKeyDown={this.onKeyDown}
                                        disabled={this.props.disabled}
                                        isInvalid={!!errors.gcf_score}
                                        min={0}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.gcf_score}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                <Form.Group as={Col} xs={6}>
                                    <Form.Label>TMT-A — Seconds</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="tmt_a_sec"
                                        value={this.state.tmt_a_sec}
                                        onChange={this.onChange}
                                        onKeyDown={this.onKeyDown}
                                        disabled={this.props.disabled}
                                        isInvalid={!!errors.tmt_a_sec}
                                        min={0}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tmt_a_sec}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} xs={6}>
                                    <Form.Label>TMT-A — Mistakes</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="tmt_a_mistakes"
                                        value={this.state.tmt_a_mistakes}
                                        onChange={this.onChange}
                                        onKeyDown={this.onKeyDown}
                                        disabled={this.props.disabled}
                                        isInvalid={!!errors.tmt_a_mistakes}
                                        min={0}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tmt_a_mistakes}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                <Form.Group as={Col} xs={6}>
                                    <Form.Label>TMT-B — Seconds</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="tmt_b_sec"
                                        value={this.state.tmt_b_sec}
                                        onChange={this.onChange}
                                        onKeyDown={this.onKeyDown}
                                        disabled={this.props.disabled}
                                        isInvalid={!!errors.tmt_b_sec}
                                        min={0}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tmt_b_sec}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} xs={6}>
                                    <Form.Label>TMT-B — Mistakes</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="tmt_b_mistakes"
                                        value={this.state.tmt_b_mistakes}
                                        onChange={this.onChange}
                                        onKeyDown={this.onKeyDown}
                                        disabled={this.props.disabled}
                                        isInvalid={!!errors.tmt_b_mistakes}
                                        min={0}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tmt_b_mistakes}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>

                        </Col>
                    </Row>
                </Form>
            </Container>
        );
    }
}

GCF_TMT.defaultProps = {
    data: null,
    disabled: false,
};

export default GCF_TMT;
